//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import CustomStore from 'devextreme/data/custom_store';
import { EncryptionService } from '../../general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../../general/exceptions-service';
import { forkJoin, lastValueFrom, map, Observable, of, switchMap } from 'rxjs';
import { HttpClientService } from '../../general/http-client-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { Injectable } from '@angular/core';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';
import { UserGroupAllocationDTO } from 'src/app/core/models/system/user-group/user-group-allocation.dto';
import { UserGroupDTO } from 'src/app/core/models/system/user-group/user-group.dto';

@Injectable({ providedIn: 'root' })

export class UserGroupService {
  
  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public addToGroup(groupId : number, userId : number, updatedByUserId : number): Observable<UserGroupDTO> {
    try {
      return forkJoin({
               groupIdEncResult         : this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>groupId),
               updatedByuserIdEncResult : this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>updatedByUserId),
               userIdEncResult          : this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>userId, true)
             })
             .pipe(
               switchMap(({ groupIdEncResult, updatedByuserIdEncResult, userIdEncResult }) => {
                 const groupIdEnc        =groupIdEncResult.result;
                 const updatedByuserIdEnc=updatedByuserIdEncResult.result;
                 const userIdEncSS       =userIdEncResult.result;
                 
                 return this.httpClientService.post(
                          environment.eSimApi +
                          eSimApiPaths.UserGroups + '/' +
                          eSimApiPaths.UserGroupsAddUserToGroup +
                          "?groupIdEnc="  + groupIdEnc +
                          "&userIdEncSS=" + userIdEncSS +
                          "&updatedByUserIdEnc=" + updatedByuserIdEnc,
                          {}
                        );
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public deleteUserAllocation(allocationId: number): Observable<boolean> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>allocationId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const idEncSS=encResult.result;
                            
                            return this.httpClientService.delete(environment.eSimApi +
                                                                  eSimApiPaths.UserGroups + "/" +
                                                                  eSimApiPaths.UserGroupsDeleteUserAllocation +
                                                                  "?idEncSS=" + idEncSS, undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public deleteUserGroup(groupId: number): Observable<boolean> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>groupId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const idEncSS=encResult.result;
                            
                            return this.httpClientService.delete(environment.eSimApi +
                                                                  eSimApiPaths.UserGroups + "/" +
                                                                  eSimApiPaths.UserGroupsDeleteUserGroup +
                                                                  "?idEncSS=" + idEncSS, undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public getById(groupId: number): Observable<UserGroupDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>groupId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const idEncSS=encResult.result;
                            
                            return this.httpClientService.getById(environment.eSimApi +
                                                                  eSimApiPaths.UserGroups + "/" +
                                                                  eSimApiPaths.UserGroupsGetUserGroupById +
                                                                  "?idEncSS=" + idEncSS, undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public GetUserGroupAllocationForCompany(companyId: number): Observable<UserGroupAllocationDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.getById(environment.eSimApi +
                                                                  eSimApiPaths.UserGroups + "/" +
                                                                  eSimApiPaths.UserGroupsGetUserGroupAllocationForCompany +
                                                                  "?companyIdEncSS=" + companyIdEncSS, undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public UserGroupsGetUserGroupByUserId(userId: number): Observable<UserGroupDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>userId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const userIdEncSS=encResult.result;
                            
                            return this.httpClientService.getById(environment.eSimApi +
                                                                  eSimApiPaths.UserGroups + "/" +
                                                                  eSimApiPaths.UserGroupsGetUserGroupByUserId +
                                                                  "?userIdEncSS=" + userIdEncSS, undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getUserGroupsForCompanyByCompanyId(companyId: number): Observable<UserGroupDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.getById(environment.eSimApi +
                                                                  eSimApiPaths.UserGroups + "/" +
                                                                  eSimApiPaths.UserGroupsGetUserGroupsForCompany +
                                                                  "?companyIdEncSS=" + companyIdEncSS, undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getUserGroupsForUserByUserId(userId: number): Observable<UserGroupDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>userId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const userIdEncSS=encResult.result;
                            
                            return this.httpClientService.getById(environment.eSimApi +
                                                                  eSimApiPaths.UserGroups + "/" +
                                                                  eSimApiPaths.UserGroupsGetUserGroupsForUser +
                                                                  "?userIdEncSS=" + userIdEncSS +
                                                                  "&unassignedOnly=false", undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getAllUserGroupsForUserByUserId(userId: number): Observable<UserGroupDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>userId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const userIdEncSS=encResult.result;
                            
                            return this.httpClientService.getById(environment.eSimApi +
                                                                  eSimApiPaths.UserGroups + "/" +
                                                                  eSimApiPaths.UserGroupsGetAllGroupsForUser +
                                                                  "?userIdEncSS=" + userIdEncSS, undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getAvailableIdAndDescription(userId: number): Observable<IdAndDescriptionDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>userId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const userIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<UserGroupDTO[]>(environment.eSimApi +
                                                                           eSimApiPaths.UserGroups + "/" + eSimApiPaths.UserGroupsGetUserGroupsForUser +
                                                                           "?userIdEncSS=" + userIdEncSS +
                                                                           "&unassignedOnly=true")
                                   .pipe(
                                     map(x => x.map(this.idAndDescriptionConverter))
                                   ); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getIdAndDescriptionForCompany(companyId: number): Observable<IdAndDescriptionDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<UserGroupDTO[]>(environment.eSimApi +
                                                                           eSimApiPaths.UserGroups + "/" + eSimApiPaths.UserGroupsGetUserGroupsForCompany +
                                                                           "?companyIdEncSS=" + companyIdEncSS)
                                   .pipe(
                                     map(x => x.map(this.idAndDescriptionConverter))
                                   ); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  private idAndDescriptionConverter(device: UserGroupDTO) {
    return {id: device.id, description: device.groupName};
  }

  public idAndDescriptionLookupDataSource(userId: number): {} {
    try {
      return {
        store: new CustomStore({
          key: "id",
          loadMode: "raw",
          load: () => {
            return lastValueFrom(this.getAvailableIdAndDescription(userId));
          }
        }),
        sort: "description"
    };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return {};
    }
  }

    public idAndDescriptionForCompanyLookupDataSource(userId: number): {} {
    try {
      return {
        store: new CustomStore({
          key: "id",
          loadMode: "raw",
          load: () => {
            return lastValueFrom(this.getIdAndDescriptionForCompany(userId));
          }
        }),
        sort: "description"
    };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return {};
    }
  }

  public removeFromGroup(groupId : number, userId : number, updatedByUserId : number): Observable<UserGroupDTO> {
    try {
      return forkJoin({
               groupIdEncResult         : this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>groupId),
               updatedByuserIdEncResult : this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>updatedByUserId),
               userIdEncResult          : this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>userId, true)
             })
             .pipe(
               switchMap(({ groupIdEncResult, updatedByuserIdEncResult, userIdEncResult }) => {
                 const groupIdEnc        =groupIdEncResult.result;
                 const updatedByuserIdEnc=updatedByuserIdEncResult.result;
                 const userIdEncSS       =userIdEncResult.result;
                 
                 return this.httpClientService.post(
                          environment.eSimApi +
                          eSimApiPaths.UserGroups + '/' +
                          eSimApiPaths.UserGroupsRemoveUserFromGroup +
                          "?groupIdEnc="  + groupIdEnc +
                          "&userIdEncSS=" + userIdEncSS +
                          "&updatedByUserIdEnc=" + updatedByuserIdEnc,
                          {}
                        );
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public post(userGroup: UserGroupDTO): Observable<UserGroupDTO> {
    try {
      //JSON.stringify(user)
      
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(userGroup), false)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.UserGroups + '/' +
                                                               eSimApiPaths.UserGroupsPost,
                                                               {objectEncSS:objectEncSS}, undefined);
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
    
  public put(userGroup: UserGroupDTO): Observable<UserGroupDTO> {
    try {
      return forkJoin({
               idEncResult       : this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>userGroup.id),
               objectEncResultSS : this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(userGroup),false)
             })
             .pipe(
               switchMap(({ idEncResult, objectEncResultSS }) => {
                 const idEnc      =idEncResult.result;
                 const objectEncSS=objectEncResultSS.result;

                 return this.httpClientService.put(environment.eSimApi +
                                                   eSimApiPaths.UserGroups + '/' +
                                                   eSimApiPaths.UserGroupsPut,
                                                   undefined,
                                                   {idEnc:idEnc, objectEncSS:objectEncSS}, undefined);
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public save(userGroup: UserGroupDTO): Observable<any> {
    try {
      //JSON.stringify(modal);
      if (userGroup.id && (<number>userGroup.id>0 || userGroup.groupName == "¬¬!!PUT!!¬¬"))
        return this.put(userGroup);
  
      return this.post(userGroup);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

}
